export default __webpack_public_path__ + "static/media/report.acac88cb.svg";